export default __webpack_public_path__ + "static/media/logo_first_tusday_negro.a7999b02.png";